window.onLoadMapWithData = function(data, id_map, filtres = "") {
    var config = data.config;

    var map = new google.maps.Map(document.getElementById('map'), {
        zoom: config.zoom,
        center: new google.maps.LatLng(config.lat, config.long),
        mapTypeId: google.maps.MapTypeId.ROADMAP
    });

    var infowindow = new google.maps.InfoWindow();
    var markers = [];
    var markerCluster;
    
    data.categories[0].infos.forEach(info => {
        var isVisible = true;
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(info.lat, info.long),
            map: map,
            icon: isVisible ? info.icon : categorie.icon,
            labels : [],
            conditionnements : [],
            cereales : [],
        });
        marker.setVisible(isVisible);

        google.maps.event.addListener(marker, 'click', (function(info, marker) {
            return function() {
                infowindow.setContent(atob(info.text));
                infowindow.open(map, marker);
            };
        })(info, marker));

        markers.push(marker);
    });

    jQuery('.select_label').change(function(e){
        displayMarkers();
    })

    function displayMarkers(){
        let filterLabel = jQuery('.select_label').val()
        let filterConditionnement = jQuery('.select_conditionnement').val()
        let filterCereales = jQuery('.select_cereales').val()

        console.log(filterLabel)
        console.log(filterCereales)
        console.log(filterConditionnement)
    }

    /*function initCategorie(categorie) {
        for (var i = 0; i < categorie.infos.length; i++) {
            var info = categorie.infos[i];
            var isVisible = true;
            console.log(isVisible + 'ok');
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(info.lat, info.long),
                map: map,
                icon: isVisible ? info.icon : categorie.icon,
                categoryId: categorie.id, // Ajout d'une propriété categoryId pour filtrer facilement
            });
            marker.setVisible(isVisible);

            google.maps.event.addListener(marker, 'click', (function(info, marker, i) {
                return function() {
                    infowindow.setContent(atob(info.text));
                    infowindow.open(map, marker);
                };
            })(info, marker, i));

            markers.push(marker);
        }
    }


    var classes = [];

    function showCategorie(categorie) {
        classes.push(categorie.classClick);
        var btn = document.getElementsByClassName(categorie.classClick)[0];

        btn.addEventListener("click", (function(id, btn_a) {
            return function() {
                markers.forEach(function(marker) {
                    var isVisible = (marker.categoryId == id);
                    marker.setVisible(isVisible);
                });
                classes.forEach(function(clazz) {
                    var btn_class = document.getElementsByClassName(clazz)[0];
                    btn_class.classList.remove("active");
                });

                btn_a.classList.add("active");

                // Met à jour les clusters pour ignorer les markers cachés
                markerCluster.clearMarkers();
                markerCluster.addMarkers(markers.filter(function(marker) {
                    return marker.getVisible();
                }));
                markerCluster.redraw();
            };
        })(categorie.id, btn));
    }

    for (var k in data.categories) {
        var categorie = data.categories[k];
        initCategorie(categorie);
        showCategorie(categorie);
    }

    // Utilisation de MarkerClusterer pour regrouper les markers
    markerCluster = new MarkerClusterer(map, markers, {
        imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
    });*/
};
